import { EventsBusService } from '../../shared/eventsBus.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { AnnouncementsService } from '../shared/announcements.service';

@Component({
  selector: 'app-announcement-view',
  templateUrl: './announcement-view.component.html',
  styleUrls: ['./announcement-view.component.css']
})
export class AnnouncementViewComponent implements OnInit {
  announcement: any;

  constructor(
    private route: ActivatedRoute,
    private service: AnnouncementsService,
    private eventsBus: EventsBusService
  ) {
    this.eventsBus.showTopBar.emit(false);
  }

  get(id: string) {
    this.service.get(id).subscribe(announcement => {
      this.announcement = announcement;
    });
  }

  ngOnInit() {
    const params = this.route.snapshot.params;

    const id = params['id'];
    if (id) {
      this.get(id);
    }
  }
}



// WEBPACK FOOTER //
// /ng-app/src/app/announcements/announcement-view/announcement-view.component.ts